// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"202":"5e2f2c2d","802":"621f9f77"}[chunkId] + ".css";
};